<template>
  <ontos-base v-bind="baseProps" ref="base">
    <div v-if="loaded && workflow">
      <ontos-page-header v-bind="heading">
        <template #actions>
          <ontos-header-action v-if="can('designer')" icon="mdi-pencil" :label="$tt('edit')"
                               :to="{name: 'edit-workflow', params: $route.params}"/>
          <ontos-header-action v-if="can('designer')" icon="mdi-delete" :label="$tt('delete')"
                               color="error" @click="deleteThis"/>
        </template>
      </ontos-page-header>
      <ontos-info-row>
        <ontos-view-info :title="$tt('workflow-name')">{{ workflow.name }}</ontos-view-info>
        <ontos-view-info :title="$tt('alias')"><span class="ontos-code">{{ workflow.alias }}</span></ontos-view-info>
      </ontos-info-row>
      <ontos-state-list :states="workflow.states" :title="$tt('states')" dense/>
    </div>
  </ontos-base>
</template>
<script lang="ts">
import {Component, toNative} from 'vue-facing-decorator'
import OntosViewInfo from "@/components/shared/ViewInfo.vue";
import {NotFoundError} from "@/errors/errors";
import WorkflowLevelRouteComponent from "@/components/shared/WorkflowLevelRouteComponent";
import InfoRow from "@/components/shared/InfoRow.vue";
import StateList from "@/components/design/workflow/StateList.vue";
import {workflowDesign} from "@/utils/heading";
import {workspaceDesignRoute} from "@/utils/breadcrumb";

@Component({components: {OntosViewInfo, 'ontos-info-row': InfoRow, 'ontos-state-list': StateList}})
class ViewWorkflow extends WorkflowLevelRouteComponent {
  get heading() {
    return workflowDesign(this.workflow!)
  }

  async load() {
    try {
      if (!this.workflow) this.throwError(this.$tt('error.load-workflow', {name: this.$route.params.workflow}))
    } catch (err) {
      if (err instanceof NotFoundError) await this.$router.push({name: 'home'})
      else this.throwError(this.$tt('error.load-workflow', {name: this.$route.params.workflow}), err)
    }
  }

  async deleteThis() {
    const workflowName = this.workflow.name;
    try {
      await this.deleteCurrentWorkflow()
      this.info(this.$tt('info.workflow-deleted', {name: workflowName}))
      await this.$router.push(workspaceDesignRoute(this.$route.params.system as string, 'workflows'))
    } catch (err) {
      this.throwError(this.$tt('error.delete-workflow', {name: workflowName}), err)
    }
  }
}

export default toNative(ViewWorkflow)
</script>
